/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$color-separator-height: 8px !default;
$color-separator-first-width: 25% !default;
$color-separator-first-color: #ea1b0a !default;
$color-separator-second-width: 12.5% !default;
$color-separator-second-color: #e3e000 !default;
$color-separator-third-width: 62.5% !default;
$color-separator-third-color: #1ea2b1 !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  position: relative;
  display: flex;
  width: 100%;
}

.#{$prefix}separator {
  position: relative;
  display: flex;
  width: 100%;
  height: $color-separator-height;

  .#{$prefix}first-color {
    width: #{$color-separator-first-width};
    height: 100%;
    background-color: $color-separator-first-color;
  }

  .#{$prefix}second-color {
    width: #{$color-separator-second-width};
    height: 100%;
    background-color: $color-separator-second-color;
  }

  .#{$prefix}third-color {
    width: #{$color-separator-third-width};
    height: 100%;
    background-color: $color-separator-third-color;
  }
}
